import type EnType from '../en-US/component';

export default {
  'component.securityScheme.formItemName.authorizationType': 'Tipo de Autorização',
  'component.securityScheme.apiKeyFormItem.name.label': 'Nome',
  'component.securityScheme.allowedSecuritySchemes': 'Esquema de Segurança Permitido',
  'component.securityScheme.preview.title': 'Security Scheme',
  'component.securityScheme.optional': 'Tornar Segurança Opcional',
  'component.securityScheme.inheritFrom': 'Herdado da pasta pai',
  'component.securityScheme.noAuthDesc': 'Nenhuma autenticação necessária',
  'component.securityScheme.useCase.empty-alert':
    'O esquema de segurança referenciado por este endpoint foi excluído. Por favor, modifique a configuração de autenticação deste endpoint.',
} satisfies typeof EnType;
